import React, { lazy } from 'react'

const EmployerProfilePage = lazy(() => import(/* webpackChunkName: "page-profile" */ '@pages/Profile/Employer'))
const WorkerProfilePage = lazy(() => import(/* webpackChunkName: "page-profile" */ '@pages/Profile/Worker'))
const EmploymentContractsPage = lazy(() =>
	import(/* webpackChunkName: "page-employment-contracts", webpackPrefetch: 3 */ '@pages/EmploymentContracts')
)
const AboutProjectPage = lazy(() => import(/* webpackChunkName: "page-about-project" */ '@pages/AboutProject'))
const ForEmployerPage = lazy(() => import(/* webpackChunkName: "page-for-employer" */ '@pages/ForEmployer'))
const ForWorkerPage = lazy(() => import(/* webpackChunkName: "page-for-worker" */ '@pages/ForWorker'))
const ReferenceInformationPage = lazy(() =>
	import(/* webpackChunkName: "page-reference-information" */ '@pages/ReferenceInformation/ReferenceInformation')
)
const FormsPage = lazy(() => import(/* webpackChunkName: "page-forms" */ '@pages/Forms/FormsPage'))
const ChooseRolePage = lazy(() =>
	import(/* webpackChunkName: "page-choose-role", webpackPrefetch: 2 */ '@pages/ChooseRole/ChooseRolePage')
)
const NotificationsPage = lazy(() => import(/* webpackChunkName: "page-notifications" */ '@pages/Notifications'))
const NotificationsMobileDetailsPage = lazy(() =>
	import(/* webpackChunkName: "page-notifications-mobile" */ '@pages/Notifications/mobile')
)
const PersonalAffairsPage = lazy(() =>
	import(/* webpackChunkName: "page-personal-affairs" */ '@pages/PersonalAffairs/PersonalAffairsPage')
)
const EmployeesPersonalFilesPage = lazy(() =>
	import(/* webpackChunkName: "page-personal-affairs" */ '@pages/EmployeesPersonalFiles/EmployeesPersonalFilesPage')
)
const LaborRecordsPage = lazy(() =>
	import(/* webpackChunkName: "page-labor-records" */ '@pages/LaborRecords/LaborRecordsPage')
)
const CheckDocumentPage = lazy(() =>
	import(/* webpackChunkName: "page-check-document" */ '@pages/CheckDocument/CheckDocument')
)
const StaffingPage = lazy(() => import(/* webpackChunkName: "page-staffing" */ '@pages/Staffing/StaffingPage'))
const GeneralInformationPage = lazy(() =>
	import(/* webpackChunkName: "page-prof-unions" */ '@pages/ProfUnions/GeneralInformationPage')
)
const TradeUnionsPage = lazy(() =>
	import(/* webpackChunkName: "page-trade-unions" */ '@pages/TradeUnionsPage/TradeUnionsPage')
)
const MembersTradeUnionPage = lazy(() =>
	import(/* webpackChunkName: "page-members-trade-union" */ '@pages/MembersTradeUnionPage/MembersTradeUnionPage')
)
const AccidentsPage = lazy(() => import(/* webpackChunkName: "page-accidents" */ '@pages/Accidents/AccidentsPage'))
const GradingPage = lazy(() => import(/* webpackChunkName: "page-grading" */ './Grading'))
const MainUnionsPage = lazy(() =>
	import(/* webpackChunkName: "page-main-unions" */ '@pages/MainUnionsPage/MainUnionsPage')
)
const CollectiveContractsPage = lazy(() =>
	import(
		/* webpackChunkName: "page-collective-contracts-page" */ '@pages/CollectiveContractsPage/CollectiveContractsPage'
	)
)
const IndustryAgreement = lazy(() =>
	import(/* webpackChunkName: "page-industry-agreement" */ '@pages/IndustryAgreement/IndustryAgreement')
)
const Reviews = lazy(() => import(/* webpackChunkName: "page-reviews" */ '@pages/Reviews/Reviews'))
const CompanyPassport = lazy(() =>
	import(/* webpackChunkName: "page-company-passport" */ '@pages/CompanyPassport/CompanyPassport')
)
const EmployerPassport = lazy(() =>
	import(/* webpackChunkName: "page-employer-passport" */ '@pages/CompanyPassport/EmployerPassport')
)
const Checks = lazy(() => import(/* webpackChunkName: "page-checks" */ '@pages/Checks/Checks'))
const MonitoringViolations = lazy(() =>
	import(/* webpackChunkName: "page-monitoring-violations" */ '@pages/MonitoringViolations/MonitoringViolations')
)
const Administration = lazy(() =>
	import(/* webpackChunkName: "page-administration" */ '@pages/Administration/Administration')
)
const SickLeave = lazy(() => import(/* webpackChunkName: "page-sick-leave" */ '@pages/SickLeave/SickLeave'))
const Payment = lazy(() => import(/* webpackChunkName: "page-payment" */ '@pages/Payment/Payment'))
const Home = lazy(() => import(/* webpackChunkName: "page-home", webpackPrefetch: 1 */ '@pages/Home/Home'))
const AppDownload = lazy(() => import(/* webpackChunkName: "page-app-download" */ '@pages/AppDownload/AppDownload'))
const RequirementLaborResources = lazy(() =>
	import(
		/* webpackChunkName: "page-requirement-labor-resources" */ '@pages/RequirementLaborResources/RequirementLaborResources'
	)
)
const ErrorPage = lazy(() => import(/* webpackChunkName: "page-error" */ '@pages/ErrorPage/ErrorPage'))
const IrsAccepted = lazy(() => import(/* webpackChunkName: "page-irs-accepted" */ '@pages/IrsAccepted/IrsAccepted'))
const WorkLog = lazy(() => import(/* webpackChunkName: "page-work-log" */ '@pages/WorkLog/WorkLog'))
const EmployerNomination = lazy(() =>
	import(/* webpackChunkName: "page-nomination-employer" */ 'pages/Nomination/EmployerNomination/EmployerNomination')
)
const MioNomination = lazy(() =>
	import(/* webpackChunkName: "page-nomination-mio" */ 'pages/Nomination/MioNomination/MioNomination')
)
const MioNominationRequest = lazy(() =>
	import(
		/* webpackChunkName: "page-nomination-mio-request" */ 'pages/Nomination/MioNominationRequest/MioNominationRequest'
	)
)
const DtspNomination = lazy(() =>
	import(/* webpackChunkName: "page-nomination-dtsp" */ '@pages/Nomination/DtspNomination/DtspNomination')
)
const DtspNominationRequest = lazy(() =>
	import(
		/* webpackChunkName: "page-nomination-dtsp-request" */ '@pages/Nomination/DtspNominationRequest/DtspNominationRequest'
	)
)
const CollectiveContracts = lazy(() =>
	import(/* webpackChunkName: "page-collective-contracts" */ '@pages/CollectiveContracts/CollectiveContracts')
)
const RegulatoryInformation1 = lazy(() =>
	import(/* webpackChunkName: "page-regulatory-information" */ '@pages/RegulatoryInformation1/RegulatoryInformation1')
)
const OccupationalRisksAssessment = lazy(() =>
	import(/* webpackChunkName: "page-occupational-risks-assessment" */ '@pages/OccupationalRisksAssessment')
)
const NewOccupationalRisksAssessment = lazy(() =>
	import(/* webpackChunkName: "page-regulatory-information" */ '@pages/NewOccupationalRisksAssessment')
)
const ContractCivilLow = lazy(() =>
	import(/* webpackChunkName: "page-contract-civil-low" */ '@pages/ContractCivilLow/ContractCivilLow')
)
const Mismatch = lazy(() => import(/* webpackChunkName: "page-mismatch" */ '@pages/Mismatch/Mismatch'))

// Публичные маршруты (без Sidebar/MainLayout)
export const publicRoutes = [
	{ element: <Home />, path: '/' },
	{ element: <AboutProjectPage />, path: '/about-project' },
	{ element: <ReferenceInformationPage />, path: '/reference-information' },
	{ element: <ChooseRolePage />, path: '/role' },
	{ element: <AppDownload />, path: '/app/download' },
	{ element: <ErrorPage />, path: '/error' },
	{ element: <ForEmployerPage />, path: '/for-employers' },
	{ element: <ForWorkerPage />, path: '/for-workers' },
]

// Основные маршруты (под MainLayout/Sidebar)
export const mainRoutes = [
	{ element: <WorkerProfilePage />, path: '/worker' },
	{ element: <EmployerProfilePage />, path: '/employer' },
	{ element: <EmploymentContractsPage />, path: '/contracts' },
	{ element: <StaffingPage />, path: '/staffing' },
	{ element: <PersonalAffairsPage />, path: '/personal-affairs' },
	{ element: <EmployeesPersonalFilesPage />, path: '/employees-personal-files' },
	{ element: <FormsPage />, path: '/forms' },
	{ element: <LaborRecordsPage />, path: '/labor-records' },
	{ element: <CompanyPassport />, path: '/company-passport' },
	{ element: <EmployerPassport />, path: '/employer-passport' },
	{ element: <MonitoringViolations />, path: '/violations' },
	{ element: <Checks />, path: '/checks' },
	// ОПР
	{ element: <OccupationalRisksAssessment />, path: '/applications-ora' },
	{ element: <NewOccupationalRisksAssessment />, path: '/applications-ora/:type/:id' },
	{ element: <RegulatoryInformation1 />, path: '/regulatory-information' },
	// уведомления
	{ element: <NotificationsPage />, path: '/notifications' },
	{ element: <NotificationsMobileDetailsPage />, path: '/notifications/:id' },
	{ element: <CheckDocumentPage />, path: '/check-document/:id/:type' },
	{ element: <GeneralInformationPage />, path: '/prof' },
	{ element: <TradeUnionsPage />, path: '/trade-unions' },
	{ element: <MainUnionsPage />, path: '/my-unions' },
	{ element: <MembersTradeUnionPage />, path: '/trade-members' },
	{ element: <CollectiveContractsPage />, path: '/col-contracts' },
	{ element: <AccidentsPage />, path: '/accidents' },
	{ element: <IndustryAgreement />, path: '/industry-agreement' },
	{ element: <Reviews />, path: '/reviews' },
	{ element: <Administration />, path: '/administration' },
	{ element: <SickLeave />, path: '/sick-leave' },
	{ element: <Payment />, path: '/payment' },
	{ element: <RequirementLaborResources />, path: '/requirement-labor-resources' },
	{ element: <IrsAccepted />, path: '/irs-accepted' },
	{ element: <WorkLog />, path: '/timing-work' },
	{ element: <EmployerNomination />, path: '/employer-nomination' },
	{ element: <MioNomination />, path: '/mio-nomination' },
	{ element: <MioNominationRequest />, path: '/mio-nomination-request' },
	{ element: <DtspNomination />, path: '/dtsp-nomination' },
	{ element: <DtspNominationRequest />, path: '/dtsp-nomination-request' },
	{ element: <CollectiveContracts />, path: '/сollective-сontracts' },
	{ element: <ContractCivilLow />, path: '/contracts-civil-low' },
	{ element: <Mismatch />, path: '/mismatch' },

	/* //TODO временно комментируется 12.09.2024 { element: <GradingPage />, path: '/grading' }, */
]
